import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BalanceSection.styles';
import { BalanceCard } from './components/BalanceCard';
import { useResponsive } from '@/hooks/useResponsive';
import {
  useCurrentUser,
  useBusinessBalance,
} from '@/features/Profile/core/hooks';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { QUERY } from '@/constants/common';
import { BusinessTabs } from '@/features/Profile/core/';
import { BusinessTabName } from '@/features/Profile/core/BusinessTabs/BusinessTabs.types';
import NoSsr from '@/components/NoSsr/NoSsr';
import { AddBalance } from '@/components/Payment/AddBalance';
import { WarningModal } from '@/components/Ad/WarningModal';
import { AdPageTestIds } from '@/__e2e__/testIds/ad-page';

export const BalanceSection = () => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsive();
  const { user } = useCurrentUser();
  const { balances, adsBalance, loading, refetchBalance } =
    useBusinessBalance();
  const [isAddBalanceOpen, toggleAddBalance] = useToggleOpenState(
    QUERY.replenishment
  );
  const [isSuccessPopupOpen, toggleSuccessPopup] = useToggleOpenState(false);

  const { isAppleGooglePayEnabled, paymentMethods } = user;

  function openAddBalance() {
    toggleAddBalance(true);
  }

  function handleTopUpSuccess() {
    toggleSuccessPopup(true);
  }

  return (
    <>
      <S.Box>
        <S.Block>
          {!isDesktop && <BusinessTabs activeTab={BusinessTabName.Balance} />}
          <S.Header>
            <S.Title>{t('pages.cabinet.balance_split')}</S.Title>
            {isDesktop && (
              <S.TopUpButton
                data-stat="business-add-balance"
                onClick={openAddBalance}
              >
                {t('pages.cabinet.replenish_account')}
              </S.TopUpButton>
            )}
          </S.Header>
          <S.Grid>
            {balances.map((item, index) => (
              <BalanceCard
                key={item.title}
                item={item}
                isLoading={loading}
                isTotal={index === balances.length - 1}
              />
            ))}
            {!isDesktop && (
              <S.TopUpButton
                data-stat="business-add-balance"
                onClick={openAddBalance}
              >
                {t('pages.cabinet.replenish_account')}
              </S.TopUpButton>
            )}
          </S.Grid>
        </S.Block>

        <S.Block>
          <S.Grid $isCount>
            <BalanceCard item={adsBalance} isLoading={loading} isCount />
          </S.Grid>
        </S.Block>
      </S.Box>

      {!isDesktop && (
        <>
          <NoSsr>
            <AddBalance
              isOpen={isAddBalanceOpen}
              toggle={toggleAddBalance}
              isAppleGooglePayEnabled={isAppleGooglePayEnabled}
              onSuccess={handleTopUpSuccess}
              onBalanceTopUpSuccess={refetchBalance}
              paymentMethods={paymentMethods}
            />
          </NoSsr>

          <WarningModal
            dataTestId={AdPageTestIds.popup.success}
            isOpen={isSuccessPopupOpen}
            onClose={() => toggleSuccessPopup(false)}
            icon="check-circle-rounded.svg"
            iconSize={30}
            title={t('pages.cabinet.add_balance_success_message')}
            description=""
          />
        </>
      )}
    </>
  );
};
